
import { Vue, Component } from 'vue-property-decorator';
import Welcome from '../../../public/welcome.svg';
import manager from '@/common/utils/permission-manager';

@Component({})
export default class Home extends Vue {
  visible = true;

  visibleType = false;

  value = '';

  svg = Welcome;

  start() {
    // this.visibleType = true;
    // this.value = '';
    // 黑卡角色
    manager.send(['menu:operation-workbench', 'shop:list', 'menu:car-shop-list']).subscribe((permissions: any) => {
      const type = 'menu:operation-workbench';
      const type1 = 'shop:list';
      const type2 = 'menu:car-shop-list';
      if (Object.keys(permissions).length > 0) {
        if (permissions[type]) {
          this.$router.push({
            name: 'workbenches.index',
          });
        } else if (permissions[type1]) {
          this.$router.push({
            name: 'main.shop.list',
          });
        } else if (permissions[type2]) {
          this.$router.push({
            name: 'car.index',
          });
        }
      }
      // name: 'workbenches.index',
      // name: 'main.shop.list',
    });
    // 二手车角色

    // 双角色
  }
  changeRole() {

  }
}
